<template>
  <div class="indexContain" id="HPIndex">
    
    <el-dropdown id="mainPageSwitch1" @command="handleCommand" v-if="false">
      <el-button type="primary">
        {{ workName }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          :command="item.id"
          v-for="(item, index) in workList"
          :key="index"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <div class="indexHeader">
      <IndexHeader :workType="workType"></IndexHeader>
    </div>
    <div class="indexInfo">
      <div class="changePro" @click="changePro">切换工程 作业</div>
      <div class="show-iframe-con">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          {{projectName}}-{{workCheckName}}
          <div class="effect"></div>
        </div>
        <iframe v-show="iframeShow" id="show-iframe"  frameborder=0 name="showHere" scrolling=auto :src="iframeSrc" ref="iframe"></iframe>
      </div>
      
      <div class="progress">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          {{ workType == 3 || workType == 4 ? "实时摊铺速度" : "实时振动频率" }}
          <div class="effect"></div>
        </div>

        <div class="infoShow" v-if="workType == 3 || workType == 4">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in pavingSpeedList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">m/min</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName }}平均速度
            </div>
          </div>
        </div>
        <div class="infoShow" v-if="workType == 1 || workType == 2">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in unrollingFrequencyList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">Hz</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName }}平均振频
            </div>
          </div>
        </div>
        <div class="progressChart" id="progressChart"></div>
      </div>
      <div class="mileage">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          {{ workType == 3 || workType == 4 ? "实时摊铺温度" : "实时振动幅度" }}
          <div class="effect"></div>
        </div>
        <div class="infoShow" v-if="workType == 3 || workType == 4">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in pavingTemperatureList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">℃</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName }}平均温度
            </div>
          </div>
        </div>
        <div class="infoShow" v-if="workType == 1 || workType == 2">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in unrollingAmplitudeList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">mm</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName }}平均振幅
            </div>
          </div>
        </div>
        <div class="workStatusChart" id="workStatusChart"></div>
      </div>
      <div class="projectTime">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          实时压实速度
          <div class="effect"></div>
        </div>

        <div class="infoShow" v-if="workType == 3 || workType == 4">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{
              rollingSpeedList.primaryRollingAvg
                ? rollingSpeedList.primaryRollingAvg
                : "--"
            }}</span>
            <span class="textLow">Kkm/h</span>
          </div>
          <div class="text_2">
            <span class="textBig">{{
              rollingSpeedList.repeatRollingAvg
                ? rollingSpeedList.repeatRollingAvg
                : "--"
            }}</span>
            <span class="textLow">km/h</span>
          </div>
          <div class="text_3">
            <span class="textBig">{{
              rollingSpeedList.finallyRollingAvg
                ? rollingSpeedList.finallyRollingAvg
                : "--"
            }}</span>
            <span class="textLow">km/h</span>
          </div>
          <div class="title_1">初压平均速度</div>
          <div class="title_2">复压平均速度</div>
          <div class="title_3">终压平均速度</div>
        </div>
        <div class="infoShow" v-if="workType == 1 || workType == 2">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in unrollingSpeedList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">km/h</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName }}平均速度
            </div>
          </div>
        </div>
        <div class="workTimeChart" id="workTimeChart"></div>
      </div>
      <div class="workTime">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          {{ workType == 3 || workType == 4 ? "实时压实遍数" : "实时压实遍数" }}
          <div class="effect"></div>
        </div>
        <div class="infoShow" v-if="workType == 3 || workType == 4">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{
              rollingTemperatureList.primaryRollingAvg
                ? rollingTemperatureList.primaryRollingAvg
                : "--"
            }}</span>
            <span class="textLow">遍</span>
          </div>
          <div class="text_2">
            <span class="textBig">{{
              rollingTemperatureList.repeatRollingAvg
                ? rollingTemperatureList.repeatRollingAvg
                : "--"
            }}</span>
            <span class="textLow">遍</span>
          </div>
          <div class="text_3">
            <span class="textBig">{{
              rollingTemperatureList.finallyRollingAvg
                ? rollingTemperatureList.finallyRollingAvg
                : "--"
            }}</span>
            <span class="textLow">遍</span>
          </div>
          <div class="title_1">{{ workType == 3 || workType == 4 ? "初压平均遍数" : "初压平均遍数" }}</div>
          <div class="title_2">{{ workType == 3 || workType == 4 ? "复压平均遍数" : "复压平均遍数" }}</div>
          <div class="title_3">{{ workType == 3 || workType == 4 ? "终压平均遍数" : "终压平均遍数" }}</div>
        </div>
        <div class="infoShow" v-if="workType == 1 || workType == 2">
          <div
            style="flex: 1; position: relative"
            v-for="(item, index) in unrollingTemperatureList"
            :key="index"
          >
            <div
              :class="index == 0 ? 'iconImg_1 icon_1' : 'iconImg_1 icon_2'"
            ></div>
            <div :class="index == 0 ? 'text_1' : 'text_1'">
              <span class="textBig">{{ item.average?item.average:'--' }}</span>
              <span class="textLow">{{ workType == 3 || workType == 4 ? "遍" : "遍" }}</span>
            </div>
            <div :class="index == 0 ? 'title_1' : 'title_1'">
              {{ item.equipName
              }}{{ workType == 3 || workType == 4 ? "平均遍数" : "平均遍数" }}
            </div>
          </div>
        </div>
        <div class="workAddUpTimeChart" id="workAddUpTimeChart"></div>
      </div>
      <div class="roadInfo" v-show="workType == 3 || workType == 4" v-if="false">
        <!-- <div class="rnimg"></div> -->
        <RollLegend
          class="rollLegend"
          fontColor="white"
          legendType="2"
        ></RollLegend>
        <div class="indexIcon"></div>
        <div class="indexTitle">
          实时压实度
          <div class="effect"></div>
        </div>
        <div class="rollIcv" id="rollIcv"></div>
      </div>
      <div class="mapInfo" v-show="workType == 3 || workType == 4" v-if="false">
        <!-- <div class="changePro" @click="changePro">切换工程 作业</div> -->
        <RollLegend
          class="rollLegend"
          fontColor="white"
          legendType="1"
        ></RollLegend>
        <div class="indexIcon"></div>
        <div class="indexTitle">
          实时碾压遍数
          <div class="effect"></div>
        </div>
        <div class="rollNumber" id="rollNumber"></div>
      </div>
      <div class="fbInfo" v-show="workType == 1 || workType == 2" v-if="false">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          {{ "作业1" }}
          <div class="effect"></div>
        </div>
        <div class="changePro" @click="changePro">切换工程 作业</div>
        <div class="fbInfoType">
          <div
            class="infoTypeItem"
            :class="[infoTypeItemNum == 1 ? 'infoActive' : '']"
            @click="infoChange(1)"
          >
            实时碾压遍数
          </div>
          <div
            class="infoTypeItem"
            :class="[infoTypeItemNum == 2 ? 'infoActive' : '']"
            @click="infoChange(2)"
          >
            实时压实度
          </div>
        </div>
        <div
          class="rnimg_1"
          :class="[infoTypeItemNum == 2 ? 'rollIndex' : '']"
        ></div>
        <div
          class="rnimg_2"
          :class="[infoTypeItemNum == 1 ? 'rollIndex' : '']"
        ></div>
        <!-- <div
          class="rollIcv"
          id="fbrollIcv"
          :class="[infoTypeItemNum == 2 ? 'rollIndex' : '']"
        ></div>
        <div
          class="rollNumber"
          id="fbrollNumber"
          :class="[infoTypeItemNum == 1 ? 'rollIndex' : '']"
        ></div> -->
        <div class="monContent">
          <Homez :roadInfoHome="roadInfoData" :infoTypeItemNumSet="infoTypeItemNum" :workIdData="workId"></Homez>
        </div>
      </div>
      <el-dialog title="切换工程、作业" :visible.sync="dialogTableVisible">
        <el-table
          @row-click="chooseProject"
          :data="projList"
          class="centralTable projectTable"
          :row-class-name="projectRowClassName"
        >
          <el-table-column prop="name" label="工程"></el-table-column>
        </el-table>
        <el-table
          @row-click="chooseWork"
          :data="tempWorkList"
          class="centralTable workTable"
          :row-class-name="workClassName"
        >
          <el-table-column prop="name" label="作业"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveAvtiveProjectSetting"
            >保存</el-button
          >
          <el-button @click="closeProjectBox">取消</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- <div class="monContent">
      <Homez></Homez>
    </div> -->
    <!-- <canvas id="midCanvasm"  :width="canvasW" :height="canvasH"></canvas>
    <canvas id="dhCanvasm" :width="canvasW" :height="canvasH"></canvas> -->
  </div>
</template>

<script>
// import BaiduMap from "vue-baidu-map/components/map/Map.vue";
// import BmScale from "vue-baidu-map/components/controls/Scale.vue";
// import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
// import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
// import BmNavigation from "vue-baidu-map/components/controls/Navigation.vue";
import IndexHeader from "../components/common/indexHeaderZ";
import { unique,format } from "../utils/commons";
import RollLegend from "../pages/quality/part/rollLegend";
import Homez from "./engineering/homez"
// import { fabric } from "fabric";
import {
  getProjectProcess,
  getProjectWorkTime,
  getProjectWorkStatus,
  getProjectworkAddUpTime,
  getIcvAndTemperature,
  getProjectActivate,
  getEnginList,
  activeEngin,
  getPavingSpeed,
  getPavingTemperature,
  getRollingSpeed,
  getRollingTemperature,
  getPileNumData,
  // getRollingTimes,
  // getRollingIcv,
  getWorks,
  getWorkInfo,
  getUnRollingTemperature,
  getUnRollingAmplitude,
  getUnRollingFrequency,
  getUnRollingSpeed,
  getDateList,
  rollingQualityTimes,
  rollingQualityIcv,
  getFbPoints,
  getRoadSectionPointer,
  getWorkEquipsList
} from "../utils/api";
import { 
  // createSocket,
 sendWSPush, 
 closeWs } from "../utils/websocket";
import Cookies from "js-cookie";
import websockMix from "../utils/websockMix";
import canvasMixRe from "../utils/canvasMixRe";
export default {
  name: "app",
  inject:['reload'],
  mixins: [websockMix,canvasMixRe],
  data() {
    return {
      iframeShow: false,
      iframeSrc: './reload/historyReloadCanvasM.shtml',
      dialogTableVisible: false,
      infoTypeItemNum: 1,
      projList: [],
      projectId: 14,
      projectName: "",
      projectProcessData: {},
      workStatusData: {},
      workTimeData: {},
      getProjectWorkTime: {},
      workAddUpTimeData: {},
      progressChart: "",
      workStatusChart: "",
      workTimeChart: "",
      workAddUpTimeChart: "",
      workId: 62,
      rollTimesHeat: "",
      rollIcvHeat: "",
      icvChart: "",
      center: {
        lng: 113.122845,
        lat: 28.246204,
      },
      colorList: ["#265DFD", "#F6C021", "#0492FF"],
      pavingSpeedList: [],
      pavingTemperatureList: [],
      rollingSpeedList: "",
      unrollingSpeedList: [],
      rollingTemperatureList: "",
      unrollingTemperatureList: [],
      unrollingAmplitudeList: [],
      unrollingFrequencyList: [],
      xAxisValue: [],
      yAxisValue: [],
      rollTimesList: [],
      rollIcvList: [],
      yData: this.$store.state.roadWidth || [1, 2, 3, 4, 5, 6, 7, 8, 9],
      setInterFun: "",
      rollTimesShow: [],
      rollIcvShow: [],
      paramsT: {},
      paramsI: {},
      workList: [],
      workName: [],
      workType: 0,
      colorBox: JSON.parse(
        JSON.stringify(this.$store.state.rollNumColorArr)
      ).reverse(),
      colorBox1: JSON.parse(
        JSON.stringify(this.$store.state.icvColorArr)
      ).reverse(),
      fbXData: [],
      fbPointers: [],
      xAxisV: [],
      yAxisV: [],
      setDataB: [],
      setDataV: [],
      minXVal: '', // 非标偏移量
      minYVal: '',
      roadInfoData: {},
      tempWorkId: null,
      tempProjectId: "",
      tempWorkList: [],
      rowIndex: 0,
      works: [],
      roadType: 0,
      iframeWin: null,
      equipmnetList: [],
      workCheckName: ''
    };
  },
  computed: {},
  created() {
    // createSocket("ws://" + localStorage.getItem("webSocketUrl") + "/ws");
  },
  mounted() {
    let that = this;
    console.log(that.$refs.iframe)
    that.iframeWin = that.$refs.iframe.contentWindow
    // setTimeout(()=>{
    //   this.canvas = new fabric.Canvas("dhCanvasm", {
    //   perPixelTargetFind: true,
    // });
    // this.midCanvasm = new fabric.Canvas("midCanvasm", {
    //   // perPixelTargetFind: true,
    // });
    //   this.initCanvasMid(that.canvas)
    // },500)
    
    getProjectActivate().then((res) => {
      this.projectId = res.data.content.info.id;
      this.tempProjectId = res.data.content.info.id;
      this.projectName = res.data.content.info.name;
      console.log(this.projectId);
      let param = {
        projectId: res.data.content.info.id,
        pageSize: 100,
      };
      getWorks(param).then((r) => {
        that.workList = r.data.content.info.list;
        that.workId = r.data.content.info.list[0].id;
        that.workName = r.data.content.info.list[0].name;
        that.workType = r.data.content.info.list[0].workType;
        console.log(that.workType,'5000')
        that.workId = localStorage.getItem('pageWorkId')!=0?localStorage.getItem('pageWorkId'):r.data.content.info.list[0].id
        that.workCheckName = localStorage.getItem('workCheckName')?localStorage.getItem('workCheckName'):r.data.content.info.list[0].name
        console.log(that.workCheckName)
        that.tempWorkList = r.data.content.info.list;
        that.tempWorkId = that.workId
        getWorkEquipsList({workId:that.workId}).then((res) => {
          this.equipmnetList = res.data.content.dataList;
          this.getRoadWidth({ id: that.workId });
        });
        let params = {
          workId: this.workId,
          startV: 80,
          endV: 100,
        };
        this.paramsT = {
          workId: this.workId,
          startT: 80,
          endT: 100,
        };
        this.paramsI = {
          workId: this.workId,
          startI: 80,
          endI: 100,
        };

        let echarts = require("echarts");
        this.progressChart = echarts.init(
          document.getElementById("progressChart")
        );
        this.workStatusChart = echarts.init(
          document.getElementById("workStatusChart")
        );
        this.workTimeChart = echarts.init(
          document.getElementById("workTimeChart")
        );
        this.workAddUpTimeChart = echarts.init(
          document.getElementById("workAddUpTimeChart")
        );
        // this.rollTimesHeat = echarts.init(
        //         document.getElementById("rollNumber")
        //       );
        //       this.rollIcvHeat = echarts.init(
        //         document.getElementById("rollIcv")
        //       );

        this.progressChart.group = "group";
        this.workStatusChart.group = "group";
        this.workTimeChart.group = "group";
        this.workAddUpTimeChart.group = "group";
        echarts.connect("group");
        
        let paramsp = {
          workId: this.workId,
        };
        if (that.workType == 2 || that.workType == 1) {
          getWorkInfo({ id: that.workId }).then((rd) => {
            this.sectionId = rd.data.content.info.sectionId;
            getDateList(params).then((res) => {
              getFbPoints({ sectionId: this.sectionId }).then((r) => {
                console.log(res)
                console.log(r)
                this.roadInfoData = r

                this.setInterFun = setInterval(function () {
                  let startV = that.progressChart.getOption()?that.progressChart.getOption().dataZoom[0].start:80;
                  let endV = that.progressChart.getOption()?that.progressChart.getOption().dataZoom[0].end:100;
                  let paramsV = params;
                  paramsV.startV = startV;
                  paramsV.endV = endV;
                  getDateList(params).then((res) => {
                    console.log(res);
                    that.fbXData = res.data.content.dataList;
                    that.getDataAll(params);
                    // that.getMidData(params); // zs
                  });
                }, 10000);
              });
              
            });
          });
          
        } else {
          getPileNumData(paramsp).then((res) => {
            //console.log(res)
            if(res.data.code==200){
              let tokenValue = Cookies.get("token");
              that.xAxisValue = res.data.content.dataList;
              let getList = res.data.content.dataList;
              let setArr = [];
              let setRollTimeArr = [];
              let setRollIcvArr = [];
              let yData = this.yData;
              for (let i = 0; i < getList.length; i++) {
                setArr.push("");
                for (let j = 0; j < yData.length; j++) {
                  setRollTimeArr.push([i, j, ""]);
                  setRollIcvArr.push([i, j, "-"]);
                }
              }
              if (that.workType == 2) {
                // that.rollTimesHeat = echarts.init(
                //   document.getElementById("fbrollNumber")
                // );
                // that.rollIcvHeat = echarts.init(
                //   document.getElementById("fbrollIcv")
                // );
              } else {
                // this.rollTimesHeat = echarts.init(
                //   document.getElementById("rollNumber")
                // );
                // this.rollIcvHeat = echarts.init(
                //   document.getElementById("rollIcv")
                // );
              }
              this.rollTimesList = setRollTimeArr;
              this.rollIcvList = setRollIcvArr;
              console.log(this.rollTimesList);
              this.yAxisValue = setArr;
              //console.log(setArr)
              that.getDataAll(params);
              // that.getMidData(params); // zs
              //获取某一个chart的start与end

              let setStr =
                "/GetWorkQuality?token=" + tokenValue + "&workId=" + this.workId;
              sendWSPush(setStr, function (res) {
                that.drawByPageZ(res);
              });
              this.setInterFun = setInterval(function () {
                let startV = that.progressChart.getOption().dataZoom[0].start;
                let endV = that.progressChart.getOption().dataZoom[0].end;
                let paramsV = params;
                paramsV.startV = startV;
                paramsV.endV = endV;
                that.getDataAll(params);
                console.log('getDataAll')
                // that.getMidData(params)
              }, 10000);
            }
           
          });
        }
      });
    });
    
  },
  methods: {
    // 获取实时数据
    // 获取道路数据
    setMessageToFrame(params){
      getRoadSectionPointer(params).then((r) => {
        this.roadType = r.data.content.dataMap.roadType;
        this.iframeShow = true
        setTimeout(()=>{
          
          console.log('join')
          this.iframeWin.postMessage({
            cmd: 'setEquipList',
            params: this.equipmnetList
          }, '*')
          if(this.roadType == 0){
            console.log('join0')
            this.iframeWin.postMessage({
              cmd: 'getFormJson',
              params: r.data.content.dataMap
            }, '*')
          }else if(this.roadType == 1){
            console.log('join1')
            this.iframeWin.postMessage({
              cmd: 'getFormJsonF',
              params: r.data.content.dataMap
            }, '*')
          }
          this.iframeWin.postMessage({
            cmd: 'setRoadType',
            params: {
              roadType: this.roadType
            }
          }, '*')
          this.iframeWin.postMessage({
            cmd: 'setProjectInfo',
            params: {
              projectId: this.projectId,
              workId: this.workId
            }
          }, '*')
          this.iframeWin.postMessage({
            cmd: 'setTime',
            params: {
              start: format(Date.parse(new Date()) - 5000),
              end: format(Date.parse(new Date())+10*60*60*1000),
              token: Cookies.get("token")
            }
          }, '*')
          console.log(format(Date.parse(new Date())))
          
        },2000)
        


      })
    },

    closeProjectBox() {
      this.dialogTableVisible = false;
      this.tempWorkId = this.workId;
      this.tempProjectId = this.projectId;
      this.tempWorkList = this.workList;
    },
    updateWork() {
      let workArray = new Array();
      for (let i = 0; i < this.workList.length; i++) {
        if (this.workList[i].id == this.workId) {
          workArray.push(this.workList[i]);
          workArray.push(this.workList[i]);
          this.currentWork = this.workList[i];
          break;
        }
      }
      // this.initMapMarker();this.workCheckName
      this.works = workArray;
      localStorage.setItem('pageWorkId',this.workId)
      localStorage.setItem('workCheckName',this.workCheckName)
      this.reload()
      // this.initFirstChart(this.workId);
    },
    saveAvtiveProjectSetting() {
      this.dialogTableVisible = false;
      this.workId = this.tempWorkId;
      this.chartOption = [];
      this.chartOptionV = {};
      this.workList = this.tempWorkList;
      this.polygonPath = [];
      this.currentWork = {name:"初始化中"};
      if (this.projectId == this.tempProjectId) {
        //仅切换作业
        this.updateWork();
      } else {
        //切换工程
        this.toActive(this.tempProjectId,this.tempWorkId);
      }
      this.projectId = this.tempProjectId;
      this.legendVisble = false;
      this.legendImgClass = 0;
      this.choose1 = 1;
      this.expandCtrl = true;
    },
    chooseProject(row) {
      this.tempProjectId = row.id;

      let params = {
        projectId: row.id,
      };

      let that = this;
      getWorks(params).then((res) => {
        that.tempWorkList = res.data.content.info.list;
        if (
          that.tempWorkList != null &&
          that.tempWorkList != undefined &&
          that.tempWorkList.length > 0
        ) {
          that.tempWorkId = that.tempWorkList[0].id;
          that.workCheckName = that.tempWorkList[0].name;
        }else{
          that.tempWorkId  = null;
        }
      });
    },
    chooseWork(row) {
      console.log(row)
      this.tempWorkId = row.id;
      this.workCheckName = row.name
    },
    projectRowClassName({ row, rowIndex }) {
      this.rowIndex = rowIndex;
      console.log(row.id)
      console.log(this.tempProjectId)
      if (row.id == this.tempProjectId) {
        return "warning-row";
      }
      return "";
    },
    workClassName({ row, rowIndex }) {
      this.rowIndex = rowIndex;
      
      if (row.id == this.tempWorkId) {
        return "warning-row";
      }
      return "";
    },
    infoChange(data) {
      this.infoTypeItemNum = data;
    },
    getRoadWidth(data) {
      getWorkInfo(data).then((res) => {
        
        let roadWidth = res.data.content.info.roadWidth;
        let deviationUnit = res.data.content.info.deviationUnit;
        let setRoadWidth = [];
        let code = deviationUnit;
        this.setMessageToFrame({sectionId: res.data.content.info.sectionId})
        
        for (let i = 0; i <= 100000; i++) {
          if (i * code <= roadWidth * 1 + code * 1) {
            setRoadWidth.push((code * 10 * i) / 10);
          }
        }
        this.yData = setRoadWidth;
        this.sectionId = res.data.content.info.sectionId;
        console.log(this.yData);
        this.$store.commit("setRoadWidth", setRoadWidth);
        this.$store.commit("deviationUnit", deviationUnit);
      });
    },
    getDataAll(params) {
      let that = this;
      // const echarts = require("echarts");
      if (this.workType == 3 || this.workType == 4) {
        getPavingSpeed(params).then((res) => {
          let getDataList = res.data.content.dataList;
          this.pavingSpeedList = res.data.content.dataList;

          // let xAxisList = that.xAxisValue;
          let xAxisList = [];

          let series = [];
          let legendList = [];
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            // let yAxisValue = JSON.parse(JSON.stringify(that.yAxisValue));
            // let yAxisValue = [];
            if(xAxisList.length == 0){
                for (let key in getDataList[i].pileDataMap) {
                  xAxisList.push(key)
                }
                xAxisList.sort()
              }
            let yAxisValue = []
            for(let n=0;n<xAxisList.length;n++){
              yAxisValue.push(getDataList[i].pileDataMap[xAxisList[n]])
            }
            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "m/min",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.progressChart.setOption(option);
        });
        getPavingTemperature(params).then((res) => {
          let getDataList = res.data.content.dataList;
          this.pavingTemperatureList = res.data.content.dataList;

          // let xAxisList = that.xAxisValue;
          let xAxisList = [];
          let series = [];
          let legendList = [];
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            // let yAxisValue = JSON.parse(JSON.stringify(that.yAxisValue));
            // let yAxisValue = [];
            if(xAxisList.length == 0){
                for (let key in getDataList[i].pileDataMap) {
                  xAxisList.push(key)
                }
                xAxisList.sort()
              }
              let yAxisValue = []
              for(let n=0;n<xAxisList.length;n++){
                yAxisValue.push(getDataList[i].pileDataMap[xAxisList[n]])
              }
            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "℃",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workStatusChart.setOption(option);
        });
        getRollingSpeed(params).then((res) => {
          let getDataList = res.data.content.info.dataList;
          this.rollingSpeedList = res.data.content.info;

          // let xAxisList = that.xAxisValue;
          let xAxisList = [];
          let series = [];
          let legendList = [];
          if(getDataList){
            for (let i = 0; i < getDataList.length; i++) {
              legendList.push(getDataList[i].equipName);
              // let yAxisValue = JSON.parse(JSON.stringify(that.yAxisValue));
              // let yAxisValue = [];
              if(xAxisList.length == 0){
                for (let key in getDataList[i].pileDataMap) {
                  xAxisList.push(key)
                }
                xAxisList.sort()
              }
              
              let yAxisValue = []
              for(let n=0;n<xAxisList.length;n++){
                yAxisValue.push(getDataList[i].pileDataMap[xAxisList[n]])
              }
              console.log(getDataList[i].pileDataMap)
              console.log(xAxisList,getDataList[i].equipName)
              console.log(yAxisValue,getDataList[i].equipName)
              let setSeries = {
                name: getDataList[i].equipName,
                type: "line",
                data: yAxisValue,
                itemStyle: {
                  normal: {
                    color: this.colorList[i],
                  },
                },
              };
              series.push(setSeries);
            }
            console.log(series)
          }
          
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "km/h",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workTimeChart.setOption(option);
        });

        getRollingTemperature(params).then((res) => {
          let getDataList = res.data.content.info.dataList;
          this.rollingTemperatureList = res.data.content.info;

          // let xAxisList = that.xAxisValue;
          let xAxisList = [];
          let series = [];
          let legendList = [];
          if(getDataList){
            for (let i = 0; i < getDataList.length; i++) {
              legendList.push(getDataList[i].equipName);
              // let yAxisValue = JSON.parse(JSON.stringify(that.yAxisValue));
              // let yAxisValue = [];
              if(xAxisList.length == 0){
                for (let key in getDataList[i].pileDataMap) {
                  xAxisList.push(key)
                }
                xAxisList.sort()
              }
              let yAxisValue = []
              for(let n=0;n<xAxisList.length;n++){
                yAxisValue.push(getDataList[i].pileDataMap[xAxisList[n]])
              }
              let setSeries = {
                name: getDataList[i].equipName,
                type: "line",
                data: yAxisValue,
                itemStyle: {
                  normal: {
                    color: this.colorList[i],
                  },
                },
              };
              series.push(setSeries);
            }
          }
          
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "遍",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workAddUpTimeChart.setOption(option);
        });
      } else {
        getUnRollingAmplitude(params).then((res) => {
          this.unrollingAmplitudeList = [];
          let getDataList = res.data.content.info.dataList;
          // for (var name in res.data.content.info.nonStandardAvgMap) {
          //   this.unrollingAmplitudeList.push({
          //     equipName: name,
          //     average: res.data.content.info.nonStandardAvgMap[name],
          //   });
          // }
          for(let i=0;i<getDataList.length;i++){
            this.unrollingAmplitudeList.push({
              equipName: getDataList[i].equipName,
              average: res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]?res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]:'-',
            });
          }
          let xAxisList = that.fbXData;
          let series = [];
          let legendList = [];
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            let yAxisValue = [];
            for (let key in getDataList[i].pileDataMap) {
              yAxisValue.push(getDataList[i].pileDataMap[key]);
            }
            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "mm",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workStatusChart.setOption(option);
        });
        getUnRollingFrequency(params).then((res) => {
          this.unrollingFrequencyList = [];
          let getDataList = res.data.content.info.dataList;
          // for (var name in res.data.content.info.nonStandardAvgMap) {
          //   this.unrollingFrequencyList.push({
          //     equipName: name,
          //     average: res.data.content.info.nonStandardAvgMap[name]?res.data.content.info.nonStandardAvgMap[name]:'-',
          //   });
          // }
          for(let i=0;i<getDataList.length;i++){
            this.unrollingFrequencyList.push({
              equipName: getDataList[i].equipName,
              average: res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]?res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]:'-',
            });
          }
          let xAxisList = that.fbXData;
          let series = [];
          let legendList = [];
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            let yAxisValue = [];
            for (let key in getDataList[i].pileDataMap) {
              yAxisValue.push(getDataList[i].pileDataMap[key]);
            }
            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "Hz",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.progressChart.setOption(option);
        });
        getUnRollingTemperature(params).then((res) => {
          this.unrollingTemperatureList = [];
          let getDataList = res.data.content.info.dataList;
          // for (var name in res.data.content.info.nonStandardAvgMap) {
          //   this.unrollingTemperatureList.push({
          //     equipName: name,
          //     average: res.data.content.info.nonStandardAvgMap[name],
          //   });
          // }
          for(let i=0;i<getDataList.length;i++){
            this.unrollingTemperatureList.push({
              equipName: getDataList[i].equipName,
              average: res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]?res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]:'-',
            });
          }
          let xAxisList = that.fbXData;
          let series = [];
          let legendList = [];
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            let yAxisValue = [];
            for (let key in getDataList[i].pileDataMap) {
              yAxisValue.push(getDataList[i].pileDataMap[key]);
            }
            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "遍",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workAddUpTimeChart.setOption(option);
        });
        getUnRollingSpeed(params).then((res) => {
          this.unrollingSpeedList = [];
          let getDataList = res.data.content.info.dataList;
          // for (var name in res.data.content.info.nonStandardAvgMap) {
          //   this.unrollingSpeedList.push({
          //     equipName: name,
          //     average: res.data.content.info.nonStandardAvgMap[name]?res.data.content.info.nonStandardAvgMap[name]:'-',
          //   });
          // }
          for(let i=0;i<getDataList.length;i++){
            this.unrollingSpeedList.push({
              equipName: getDataList[i].equipName,
              average: res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]?res.data.content.info.nonStandardAvgMap[getDataList[i].equipName]:'-',
            });
          }
          // let xAxisList = that.xAxisValue
          let series = [];
          let legendList = [];
          let xAxisList = that.fbXData;
          for (let i = 0; i < getDataList.length; i++) {
            legendList.push(getDataList[i].equipName);
            let yAxisValue = [];
            for (let key in getDataList[i].pileDataMap) {
              yAxisValue.push(getDataList[i].pileDataMap[key]);
            }

            let setSeries = {
              name: getDataList[i].equipName,
              type: "line",
              data: yAxisValue,
              itemStyle: {
                normal: {
                  color: this.colorList[i],
                },
              },
            };
            series.push(setSeries);
          }
          let option = {
            legend: {
              data: legendList,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 40,
              itemHeight: 10,
              itemWidth: 20,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 60,
              top: 70,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "km/h",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: params.startV,
                end: params.endV,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.workTimeChart.setOption(option);
        });
      }
    },
    getMidData(params) {
      let that = this;
      // const echarts = require("echarts");
      rollingQualityTimes(params).then((r) => {
        console.log(r);
        let res = r.data.content.info;
        if (this.workType == 2 || this.workType == 1) {
          if (res.data == []) {
            // getWorkInfo({ id: params.workId }).then((e) => {
            //   getFbPoints({
            //     sectionId: e.data.content.info.sectionId,
            //   }).then((s) => {});
            // });
            return;
          }
          if (res == null) res = {};
          res.average =
            res.average == undefined ? null : res.average.toFixed(2);
          res.standardDiff =
            res.standardDiff == undefined ? null : res.standardDiff.toFixed(2);
          res.passRate =
            res.passRate == undefined
              ? null
              : (res.passRate * 100).toFixed(2) + "%";
          res.max = res.max == undefined ? null : res.max;
          res.min = res.min == undefined ? null : res.min;
          this.leftData = res;
          res.data = res.data ? res.data : [];
          let xAxisObj = {};
          var xAxisData = res.data.map((item) => item[0]);
          // var yAxisData = this.$store.state.roadWidth;
          xAxisData = unique(xAxisData);
          for (let i = 0; i < xAxisData.length; i++) {
            xAxisObj[xAxisData[i]] = i;
          }
          let data = [];
          const dataMap = {};
          res.data.map((item) => {
            const y = Math.floor(Math.random() * 6);
            dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
          });
          let code = this.$store.state.deviationUnit;
          for (let i = 0; i < res.data.length; i++) {
            let arr = [
              xAxisObj[res.data[i][0]],
              (res.data[i][1] * 10) / (code * 10),
              res.data[i][2],
            ];
            data.push(arr);
          }
          that.setDataB = []
          that.setDataB = data
          this.zfCode = 0
          console.log(this.setDataB)
          // console.log(data,"rollingTimes")

          // const colorBox =  this.$store.state.rollNumColorArr.reverse();
          // const colorBox = JSON.parse(
          //   JSON.stringify(this.$store.state.rollNumColorArr)
          // ).reverse();
          let colorList = this.$store.state.rollNumColor;
          let keys = Object.keys(colorList);
          let setArr = []
          for(let i=0;i<keys.length;i++){
            setArr.push({
              min: keys[i]*1,
              max: keys[i]*1
            })
          }
          setArr[setArr.length-1].max = 200
          // let chartOption = {
          //   visualMap: {
          //     type: "piecewise",
          //     min: 0,
          //     max: 100,
          //     calculable: true,
          //     realtime: false,
          //     orient: "horizontal",
          //     left: "center",
          //     bottom: "15%",
          //     show: false,
          //     pieces: setArr,
          //     color: colorBox,
          //   },
          //   tooltip: {
          //     position: "top",
          //     // formatter: '{a}: {b}<br />{c}: {d}'
          //   },
          //   xAxis: {
          //     type: "category",
          //     data: xAxisData,
          //     splitArea: {
          //       show: true,
          //     },
          //     splitLine: {
          //       show: false,
          //     },
          //     axisLabel: {
          //       lineStyle: {
          //         color: "#878787",
          //       },
          //       color: "#ffffff",
          //       fontSize: 10,
          //     },
          //     axisLine: {
          //       lineStyle: {
          //         color: "#878787",
          //       },
          //     },
          //     axisTick: {
          //       show: false,
          //     },
          //   },
          //   yAxis: [
          //     {
          //       type: "category",
          //       data: yAxisData,
          //       splitArea: {
          //         show: true,
          //       },
          //       splitLine: {
          //         show: false,
          //       },
          //       axisLabel: {
          //         lineStyle: {
          //           color: "#878787",
          //         },
          //         color: "#ffffff",
          //         fontSize: 10,
          //       },
          //       axisLine: {
          //         lineStyle: {
          //           color: "#878787",
          //         },
          //       },
          //       axisTick: {
          //         show: false,
          //       },
          //     },
          //   ],
          //   series: [
          //     {
          //       name: "遍数",
          //       type: "heatmap",
          //       data: data,
          //       label: {
          //         show: false,
          //       },
          //       emphasis: {
          //         itemStyle: {
          //           shadowBlur: 10,
          //           shadowColor: "rgba(0, 0, 0, 0.5)",
          //         },
          //       },
          //     },
          //     {
          //       id: "a",
          //       type: "line",
          //       smooth: true,
          //       symbolSize: 0,
          //       data: this.fbPointers,
          //       // data: ,
          //       lineStyle: {
          //         color: "#000",
          //       },
          //     },
          //   ],
          //   dataZoom: [
          //     {
          //       type: "slider",
          //       show: true,
          //       realtime: true,
          //       start: 90,
          //       end: 100,
          //       handleSize: "10%",
          //       height: 10,
          //       handleStyle: {
          //         borderWidth: 2,
          //       },
          //       bottom: "0%",
          //       borderColor: "#0492FF",
          //       fillerColor: "#265DFD",
          //       textStyle: {
          //         color: "#ffffff",
          //       },
          //     },
          //     {
          //       type: "inside",
          //       xAxisIndex: [0],
          //     },
          //     {
          //       type: "slider",
          //       yAxisIndex: [0],
          //       show: true,
          //       // zoomLock: false,
          //       borderColor: "#0492FF",
          //       fillerColor: "#265DFD",
          //       start: 0,
          //       end: 10,
          //       handleSize: "5%",
          //       width: 10,
          //       handleStyle: {
          //         borderWidth: 2,
          //       },
          //       textStyle: {
          //         color: "#ffffff",
          //       },
          //     },
          //     {
          //       type: "inside",
          //       yAxisIndex: [0],
          //     },
          //   ],
          // };
          // this.rollTimesHeat.setOption(chartOption);
        } else {
          let dataList = r.data.content.info.data; // 获取到的初始数据
          let xAxisList = that.xAxisValue; // X轴的数据
          let getData = this.rollTimesList; // 获取到的初始全为空的数据
          let yCode = this.yData[this.yData.length - 1];
          console.log(yCode);
          console.log(getData);
          let yAxisData = this.$store.state.roadWidth;
          let code = this.$store.state.deviationUnit;
          for (let i = 0; i < dataList.length; i++) {
            if (xAxisList.indexOf(dataList[i][0]) >= 0) {
              if (dataList[i][1] <= 14) {
                let setNum =
                  xAxisList.indexOf(dataList[i][0]) * yAxisData.length +
                  (dataList[i][1] * 10) / (code * 10);
                // console.log(setNum)
                // console.log(i)
                // console.log(setNum)
                getData[setNum][2] = dataList[i][2];
              }
            }
          }
          console.log(getData);
          that.rollTimesShow = getData;

          const colorBox = this.colorBox;
          let colorList = this.$store.state.rollNumColor;
          let keys = Object.keys(colorList);
          let setArr = []
          for(let i=0;i<keys.length;i++){
            setArr.push({
              min: keys[i]*1,
              max: keys[i]*1
            })
          }
          setArr[setArr.length-1].max = 200
          let chartOption = {
            visualMap: {
              type: "piecewise",
              min: 0,
              max: 10,
              calculable: true,
              realtime: false,
              orient: "horizontal",
              left: "center",
              bottom: "15%",
              show: false,
              pieces: setArr,
              color: colorBox,
            },
            tooltip: {
              position: "top",
              formatter: function (a) {
                console.log(a);
                let str = a.data[2] ? a.data[2] : "暂无";
                return a.name + ":" + " " + str;
              },
            },
            animation: false,
            grid: {
              height: "70%",
              top: "10%",
            },
            xAxis: {
              type: "category",
              data: xAxisList,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
            yAxis: {
              type: "category",
              data: this.yData,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            series: [
              {
                // name: "Punch Card",
                type: "heatmap",
                data: getData,
                label: {
                  show: false,
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 90,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "10%",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
                textStyle: {
                  color: "#ffffff",
                },
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
          };
          this.rollTimesHeat.setOption(chartOption);
        }
      });
      rollingQualityIcv(params).then((r) => {
        console.log(res);
        let res = r.data.content.info;
        if (this.workType == 2) {
          if (res.data == []) {
            return;
          }
          if (res == null) res = {};
          console.log(res, "heartMap");
          res.max = res.max == undefined ? null : res.max.toFixed(0);
          res.min = res.min == undefined ? null : res.min.toFixed(0);
          res.average =
            res.average == undefined ? null : res.average.toFixed(2);
          res.standardDiff =
            res.standardDiff == undefined ? null : res.standardDiff.toFixed(2);
          res.passRate =
            res.passRate == undefined
              ? null
              : (res.passRate * 100).toFixed(2) + "%";
          res.overRate =
            res.overRate == undefined
              ? null
              : (res.overRate * 100).toFixed(2) + "%";
          res.lackRate =
            res.lackRate == undefined
              ? null
              : (res.lackRate * 100).toFixed(2) + "%";
          this.leftData = res;
          res.data = res.data == undefined ? [] : res.data;
          // console.log(res);
          let xAxisObj = {};
          let xAxisData = res.data.map((item) => item[0]);
          // xAxisData.length = 100;
          // let yAxisData = this.$store.state.roadWidth;
          xAxisData = unique(xAxisData);
          for (let i = 0; i < xAxisData.length; i++) {
            xAxisObj[xAxisData[i]] = i;
          }
          //console.log(xAxisObj);
          let data = [];
          const dataMap = {};
          res.data.map((item) => {
            const y = Math.floor(Math.random() * 6);
            dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
          });
          
          let code = this.$store.state.deviationUnit;
          for (let i = 0; i < res.data.length; i++) {
            let arr = [
              xAxisObj[res.data[i][0]],
              (res.data[i][1] * 10) / (code * 10),
              res.data[i][2].toFixed(0) * 1,
            ];
            data.push(arr);
          }
          this.zfCode = 0
          that.setDataV = data
          // const colorBox = JSON.parse(
          //   JSON.stringify(this.$store.state.icvColorArr)
          // ).reverse();
          let colorList = this.$store.state.icvColor;
          let keys = Object.keys(colorList);
          let setArr = []
          for(let i=0;i<keys.length;i++){
            setArr.push({
              min: keys[i-1]?keys[i-1]*1+1:0,
              max: keys[i]*1
            })
          }

          // let chartOption = {
          //   visualMap: {
          //     type: "piecewise",
          //     min: 0,
          //     max: 100,
          //     calculable: true,
          //     realtime: false,
          //     orient: "horizontal",
          //     left: "center",
          //     bottom: "15%",
          //     show: false,
          //     pieces: setArr,
          //     color: colorBox,
          //   },
          //   tooltip: {
          //     position: "top",
          //   },
          //   xAxis: {
          //     type: "category",
          //     data: xAxisData,
          //     splitArea: {
          //       show: true,
          //     },
          //     splitLine: {
          //       show: false,
          //     },
          //     axisLabel: {
          //       lineStyle: {
          //         color: "#ffffff",
          //       },
          //       color: "#ffffff",
          //       fontSize: 10,
          //     },
          //     axisLine: {
          //       lineStyle: {
          //         color: "#878787",
          //       },
          //     },
          //     axisTick: {
          //       show: false,
          //     },
          //   },
          //   yAxis: {
          //     type: "category",
          //     data: yAxisData,
          //     splitArea: {
          //       show: true,
          //     },
          //     nameTextStyle: {
          //       color: "#ffffff",
          //       fontSize: 10,
          //     },
          //     splitLine: {
          //       show: false,
          //     },
          //     axisLabel: {
          //       lineStyle: {
          //         color: "#ffffff",
          //       },
          //       color: "#ffffff",
          //       fontSize: 10,
          //     },
          //     axisLine: {
          //       lineStyle: {
          //         color: "#878787",
          //       },
          //     },
          //     axisTick: {
          //       show: false,
          //     },
          //   },
          //   series: [
          //     {
          //       name: "压实度",
          //       type: "heatmap",
          //       data: data,
          //       label: {
          //         show: false,
          //       },
          //       emphasis: {
          //         itemStyle: {
          //           shadowBlur: 10,
          //           shadowColor: "rgba(0, 0, 0, 0.5)",
          //         },
          //       },
          //     },
          //   ],
          //   dataZoom: [
          //     {
          //       type: "slider",
          //       show: true,
          //       realtime: true,
          //       start: 90,
          //       end: 100,
          //       handleSize: "10%",
          //       height: 10,
          //       handleStyle: {
          //         borderWidth: 2,
          //       },
          //       bottom: "0%",
          //       borderColor: "#0492FF",
          //       fillerColor: "#265DFD",
          //       textStyle: {
          //         color: "#ffffff",
          //       },
          //     },
          //     {
          //       type: "inside",
          //       xAxisIndex: [0],
          //     },
          //     {
          //       type: "slider",
          //       yAxisIndex: [0],
          //       show: true,
          //       // zoomLock: false,
          //       borderColor: "#0492FF",
          //       fillerColor: "#265DFD",
          //       start: 0,
          //       end: 10,
          //       handleSize: "5%",
          //       width: 10,
          //       handleStyle: {
          //         borderWidth: 2,
          //       },
          //       textStyle: {
          //         color: "#ffffff",
          //       },
          //     },
          //     {
          //       type: "inside",
          //       yAxisIndex: [0],
          //     },
          //   ],
          // };
          // this.rollIcvHeat.setOption(chartOption);
        } else {
          let dataList = r.data.content.info.data; // 获取到的初始数据
          let xAxisList = that.xAxisValue; // X轴的数据
          let getData = this.rollIcvList; // 获取到的初始全为空的数据
          let yCode = this.yData[this.yData.length - 1];
          console.log(yCode);
          var yAxisData = this.$store.state.roadWidth;
          let code = this.$store.state.deviationUnit;
          for (let i = 0; i < dataList.length; i++) {
            if (xAxisList.indexOf(dataList[i][0]) >= 0) {
              if (dataList[i][1] <= 14) {
                let setNum =
                  xAxisList.indexOf(dataList[i][0]) * yAxisData.length +
                  (dataList[i][1] * 10) / (code * 10);
                getData[setNum][2] = dataList[i][2];
              }
            }
          }
          that.rollIcvShow = getData;
          console.log(getData);
          const colorBox = this.colorBox1;
          let colorList = this.$store.state.icvColor;
          let keys = Object.keys(colorList);
          let setArr = []
          for(let i=0;i<keys.length;i++){
            setArr.push({
              min: keys[i-1]?keys[i-1]*1+1:0,
              max: keys[i]*1
            })
          }
          let chartOption = {
            visualMap: {
              type: "piecewise",
              min: 0,
              max: 10,
              calculable: true,
              realtime: false,
              orient: "horizontal",
              left: "center",
              bottom: "15%",
              show: false,
              pieces: setArr,
              color: colorBox,
            },
            tooltip: {
              position: "top",
              formatter: function (a) {
                console.log(a);
                let str = a.data[2];
                return a.name + ":" + " " + str;
              },
            },
            animation: false,
            grid: {
              height: "70%",
              top: "10%",
            },
            xAxis: {
              type: "category",
              data: xAxisList,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
            yAxis: {
              type: "category",
              data: this.yData,
              splitArea: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            series: [
              {
                name: "压实度",
                type: "heatmap",
                data: getData,
                label: {
                  show: false,
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 90,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "10%",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
          };
          this.rollIcvHeat.setOption(chartOption);
        }
      });
    },
    handleCommand(command) {
      let that = this;
      console.log(command);
      this.workId = command;
      let getList = this.workList;
      for (let i = 0; i < getList.length; i++) {
        if (getList[i].id == command) {
          this.workName = getList[i].name;
          this.workType = getList[i].workType;
        }
      }
      clearInterval(this.setInterFun);
      let paramsp = {
        workId: this.workId,
      };
      let params = {
        workId: this.workId,
        startV: 80,
        endV: 100,
      };
      this.paramsT = {
        workId: this.workId,
        startT: 80,
        endT: 100,
      };
      this.paramsI = {
        workId: this.workId,
        startI: 80,
        endI: 100,
      };
      this.workStatusChart.clear();
      this.progressChart.clear();
      this.workAddUpTimeChart.clear();
      this.workTimeChart.clear();
      if(that.workType == 4){
        this.rollTimesHeat.clear();
        this.rollIcvHeat.clear();
      }
      
      if (that.workType == 2 || that.workType == 1) {
        getWorkInfo({ id: this.workId }).then((e) => {
          getFbPoints({ sectionId: e.data.content.info.sectionId }).then(
            (s) => {
              this.roadInfoData = s
              // this.initCanvasMid(this.canvas)
              this.minXVal = s.data.content.dataMap.minX
              this.minYVal = s.data.content.dataMap.minY
              let getPList = s.data.content.dataMap.points;
              let setPList = [];
              for (let i = 0; i < getPList.length; i++) {
                setPList.push([getPList[i].x * 3.33, getPList[i].y * 3.33]);
              }
              this.fbPointers = setPList;

              let list = s.data.content.dataMap.points;
              let xl = [];
              let yl = [];
              for (let i = 0; i < list.length; i++) {
                xl.push(list[i].x * 1);
                yl.push(list[i].y * 1);
              }
              let xmax = Math.max(...xl);
              let ymax = Math.max(...yl);
              let xAxisV = [];
              let yAxisV = [];
              let setData = [];
              for (let i = 0; i < Math.ceil(xmax / 0.3); i++) {
                xAxisV.push((i * 0.3).toFixed(1) * 1);
              }
              for (let j = 0; j < Math.ceil(ymax / 0.3); j++) {
                yAxisV.push((j * 0.3).toFixed(1) * 1);
              }
              this.xAxisV = xAxisV
              this.yAxisV = yAxisV
              for (let m = 0; m < xAxisV.length; m++) {
                for (let n = 0; n < yAxisV.length; n++) {
                  setData.push([xAxisV[m], yAxisV[n], ""]);
                }
              }
              // this.setData = setData
              // console.log(this.setData)
              // const colorBox = JSON.parse(
              //   JSON.stringify(this.$store.state.rollNumColorArr)
              // ).reverse();
              let colorList = this.$store.state.rollNumColor;
              let keys = Object.keys(colorList);
              let setArr = []
              for(let i=0;i<keys.length;i++){
                setArr.push({
                  min: keys[i]*1,
                  max: keys[i]*1
                })
              }
              setArr[setArr.length-1].max = 200
              // let chartOption = {
              //   visualMap: {
              //     type: "piecewise",
              //     min: 0,
              //     max: 100,
              //     calculable: true,
              //     realtime: false,
              //     orient: "horizontal",
              //     left: "center",
              //     bottom: "15%",
              //     show: false,
              //     pieces: setArr,
              //     color: colorBox,
              //   },
              //   tooltip: {
              //     position: "top",
              //     // formatter: '{a}: {b}<br />{c}: {d}'
              //   },
              //   xAxis: {
              //     type: "category",
              //     data: xAxisV,
              //     splitArea: {
              //       show: true,
              //     },
              //     splitLine: {
              //       show: false,
              //     },
              //     axisLabel: {
              //       lineStyle: {
              //         color: "#878787",
              //       },
              //       color: "#ffffff",
              //       fontSize: 10,
              //     },
              //     axisLine: {
              //       lineStyle: {
              //         color: "#878787",
              //       },
              //     },
              //     axisTick: {
              //       show: false,
              //     },
              //   },
              //   yAxis: [
              //     {
              //       type: "category",
              //       data: yAxisV,
              //       splitArea: {
              //         show: true,
              //       },
              //       splitLine: {
              //         show: false,
              //       },
              //       axisLabel: {
              //         lineStyle: {
              //           color: "#878787",
              //         },
              //         color: "#ffffff",
              //         fontSize: 10,
              //       },
              //       axisLine: {
              //         lineStyle: {
              //           color: "#878787",
              //         },
              //       },
              //       axisTick: {
              //         show: false,
              //       },
              //     },
              //   ],
              //   series: [
              //     {
              //       name: "遍数",
              //       type: "heatmap",
              //       data: setData,
              //       label: {
              //         show: false,
              //       },
              //       emphasis: {
              //         itemStyle: {
              //           shadowBlur: 10,
              //           shadowColor: "rgba(0, 0, 0, 0.5)",
              //         },
              //       },
              //     },
              //     {
              //       id: "a",
              //       type: "line",
              //       smooth: true,
              //       symbolSize: 0,
              //       data: this.fbPointers,
              //       // data: ,
              //       lineStyle: {
              //         color: "#000",
              //       },
              //     },
              //   ],
              //   dataZoom: [
              //     {
              //       type: "slider",
              //       show: true,
              //       realtime: true,
              //       start: 90,
              //       end: 100,
              //       handleSize: "10%",
              //       height: 10,
              //       handleStyle: {
              //         borderWidth: 2,
              //       },
              //       bottom: "0%",
              //       borderColor: "#0492FF",
              //       fillerColor: "#265DFD",
              //       textStyle: {
              //         color: "#ffffff",
              //       },
              //     },
              //     {
              //       type: "inside",
              //       xAxisIndex: [0],
              //     },
              //     {
              //       type: "slider",
              //       yAxisIndex: [0],
              //       show: true,
              //       // zoomLock: false,
              //       borderColor: "#0492FF",
              //       fillerColor: "#265DFD",
              //       start: 0,
              //       end: 10,
              //       handleSize: "5%",
              //       width: 10,
              //       handleStyle: {
              //         borderWidth: 2,
              //       },
              //       textStyle: {
              //         color: "#ffffff",
              //       },
              //     },
              //     {
              //       type: "inside",
              //       yAxisIndex: [0],
              //     },
              //   ],
              // };
              // this.rollTimesHeat.setOption(chartOption);
              // this.rollIcvHeat.setOption(chartOption);
              getDateList(params).then((res) => {
                console.log(res);
                that.fbXData = res.data.content.dataList;
                that.getDataAll(params);
                // that.getMidData(params); // zs
              });
              // let tokenValue = Cookies.get("token");
              // let setStr =
              //   "/GetWorkStatus?token=" + tokenValue + "&workId=" + params.workId;
              // let canvasM = document.getElementById('midCanvas'); //画布对象
              // let contextM = canvasM.getContext('2d');//画布显示二维图片
              // let that = this
              // sendWSPush(setStr, function (res) {
              //   that.drawByPageZF(res,contextM);
              // });
              this.setInterFun = setInterval(function () {
                let startV = that.progressChart.getOption().dataZoom[0].start;
                let endV = that.progressChart.getOption().dataZoom[0].end;
                let paramsV = params;
                paramsV.startV = startV;
                paramsV.endV = endV;
                getDateList(params).then((res) => {
                  console.log(res);
                  that.fbXData = res.data.content.dataList;
                  that.getDataAll(params);
                  // that.getMidData(params); // zs
                });
              }, 10000);
            }
          );
          
        });

        
      } else {
        getPileNumData(paramsp).then((res) => {
          //console.log(res)
          let tokenValue = Cookies.get("token");
          that.xAxisValue = res.data.content.dataList;
          let getList = res.data.content.dataList;
          let setArr = [];
          let setRollTimeArr = [];
          let setRollIcvArr = [];
          let yData = this.yData;
          for (let i = 0; i < getList.length; i++) {
            setArr.push("");
            for (let j = 0; j < yData.length; j++) {
              setRollTimeArr.push([i, j, ""]);
              setRollIcvArr.push([i, j, ""]);
            }
          }
          this.rollTimesList = setRollTimeArr;
          this.rollIcvList = setRollIcvArr;
          console.log(this.rollTimesList);
          this.yAxisValue = setArr;
          //console.log(setArr)
          that.getDataAll(params);
          // that.getMidData(params); // zs
          //获取某一个chart的start与end

          let setStr =
            "/GetWorkQuality?token=" + tokenValue + "&workId=" + this.workId;
          sendWSPush(setStr, function (res) {
            that.drawByPageZ(res);
          });
          this.setInterFun = setInterval(function () {
            let startV = that.progressChart.getOption().dataZoom[0].start;
            let endV = that.progressChart.getOption().dataZoom[0].end;
            let paramsV = params;
            paramsV.startV = startV;
            paramsV.endV = endV;
            that.getDataAll(params);
            // that.getMidData(params)
          }, 10000);
        });
      }
    },
    toActive(setId,workId) {
      let params = {
        id: setId,
      };
      
      activeEngin(params).then(() => {
        localStorage.setItem('pageWorkId',workId)
        localStorage.setItem('workCheckName',this.workCheckName)
        this.reload()
        // this.getProjectList();
        // getProjectActivate().then((res) => {
        //   this.projectId = res.data.content.info.id;
        //   this.projectName = res.data.content.info.name;
        //   this.getIndexInfo();
        // });
      });
    },
    getProjectList() {
      getEnginList({ pageSize: 100 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        ////console.log(currentProject)
        this.projectId = currentProject.id;
        //获取 统计数据
        // this.getIndexInfo();
      });
    },
    changePro: function () {
      this.dialogTableVisible = true;
      this.getProjectList();
    },
    toLogin() {
      ////console.log('1')
      this.$router.push({ name: "Login" });
    },
    toTransfer() {
      this.$router.push({ name: "Transfer" });
    },
    getIndexInfo() {
      let params = {
        projectId: this.projectId,
      };
      this.$parent.initRollParameter(this.projectId);
      const echarts = require("echarts");
      getProjectProcess(params).then((res) => {
        let getData = res.data.content.info;
        getData.meanMileage = getData.meanMileage.toFixed(0);
        getData.process = getData.process.toFixed(0);
        getData.mileage = getData.mileage.toFixed(0);
        this.projectProcessData = getData;

        this.progressChart = echarts.init(
          document.getElementById("progressChart")
        );
        const xAxisList = getData.data.map((item) => item.name);
        const series = [
          {
            name: "每日作业里程",
            type: "bar",
            barWidth: 10,
            data: getData.data.map((item) => {
              return item.values[0].toFixed(1);
            }),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#265DFD",
                  },
                  {
                    offset: 1,
                    color: "#0492FF",
                  },
                ]),
              },
            },
          },
          {
            name: "工程进度",
            type: "line",
            yAxisIndex: 1,
            data: getData.data.map((item) => {
              return (item.values[1] * 100).toFixed(1);
            }),
            itemStyle: {
              normal: {
                color: "#F6C021",
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["每日作业里程", "工程进度"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 70,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "(km)",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 10,
              },
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            {
              type: "value",
              name: "",
              min: 0,
              max: 100,
              // interval: 25,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
                formatter: "{value} %",
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 80,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "0",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        };
        this.progressChart.setOption(option);
      });

      getProjectWorkTime(params).then((res) => {
        //console.log(res)
        let getData = res.data.content.info;
        this.workTimeData = res.data.content.info;
        this.workTimeChart = echarts.init(
          document.getElementById("workTimeChart")
        );
        const xAxisList = getData.data.map((item) => item.name);
        const series = [
          {
            name: "施工时长",
            type: "bar",
            barWidth: 10,
            data: getData.data.map((item) => {
              return item.values[0].toFixed(1);
            }),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#265DFD",
                  },
                  {
                    offset: 1,
                    color: "#0492FF",
                  },
                ]),
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["施工时长"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 40,
            top: 70,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "(H)",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 10,
              },
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 80,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "0",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        };
        this.workTimeChart.setOption(option);
      });

      getProjectWorkStatus(params).then((res) => {
        //console.log(res)
        let getData = res.data.content.info;
        this.workStatusData = res.data.content.info;
        this.workStatusChart = echarts.init(
          document.getElementById("workStatusChart")
        );
        const yAxisList = getData.subData.map((item) => item.workName);
        const statusArr = getData.subData.map((item) => item.workStatus);
        const series = [
          {
            name: "",
            type: "bar",
            barWidth: 10,
            data: getData.subData.map((item) => {
              return item.percentage * 100;
            }),
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#7B68EE",
                      },
                      {
                        offset: 1,
                        color: "#800080",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#3156CF",
                      },
                      {
                        offset: 1,
                        color: "#7650FB",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#265DFD",
                      },
                      {
                        offset: 1,
                        color: "#0492FF",
                      },
                    ]),
                  ];

                  return colorList[statusArr[params.dataIndex] - 1];
                },
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["已完成"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function (params) {
              let status = "";
              if (statusArr[params[0].dataIndex] == 1) {
                status = "已完成";
              } else if (statusArr[params[0].dataIndex] == 2) {
                status = "施工中";
              } else if (statusArr[params[0].dataIndex] == 3) {
                status = "未施工";
              }
              let str = params[0].name + "</br>";
              str = str + "作业进度:" + params[0].data + "%" + "</br>";
              str = str + "作业状态:" + status;
              return str;
            },
          },
          grid: {
            left: 70,
            right: 60,
            top: 40,
            bottom: 40,
          },
          xAxis: {
            type: "value",
            name: "(%)",
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
              formatter: function (value) {
                return value + "%";
              },
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            position: "top",
          },

          yAxis: {
            type: "category",

            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            data: yAxisList,
          },
          series: series,
        };
        this.workStatusChart.setOption(option);
      });

      getProjectworkAddUpTime(params).then((res) => {
        //console.log(res)
        let getData = res.data.content.info;
        this.workAddUpTimeData = res.data.content.info;
        this.workAddUpTimeChart = echarts.init(
          document.getElementById("workAddUpTimeChart")
        );
        const yAxisList = getData.subData.map((item) => item.workName);
        const statusArr = getData.subData.map((item) => item.workStatus);
        const series = [
          {
            name: "",
            type: "bar",
            barWidth: 10,
            data: getData.subData.map((item) => {
              return item.workTime;
            }),
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#3156CF",
                      },
                      {
                        offset: 1,
                        color: "#7650FB",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#0492FF",
                      },
                      {
                        offset: 1,
                        color: "#265DFD",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#D4893F",
                      },
                      {
                        offset: 1,
                        color: "#F9A562",
                      },
                    ]),
                  ];
                  //console.log(params)
                  //console.log(params.dataIndex)
                  return colorList[statusArr[params.dataIndex] - 1];
                },
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["已完成"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function (params) {
              let status = "";
              if (statusArr[params[0].dataIndex] == 1) {
                status = "按时完成";
              } else if (statusArr[params[0].dataIndex] == 2) {
                status = "超时完成";
              } else if (statusArr[params[0].dataIndex] == 3) {
                status = "未完成";
              }
              let str = params[0].name + "</br>";
              str = str + "施工时长:" + params[0].data + "H" + "</br>";
              str = str + "作业状态:" + status;
              return str;
            },
          },
          grid: {
            left: 70,
            right: 60,
            top: 40,
            bottom: 40,
          },
          xAxis: {
            type: "value",
            name: "(H)",
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
              formatter: function (value) {
                return value + "H";
              },
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            position: "top",
          },

          yAxis: {
            type: "category",

            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            data: yAxisList,
          },
          series: series,
        };
        this.workAddUpTimeChart.setOption(option);
      });

      getIcvAndTemperature(params).then((res) => {
        //console.log(res)
        let colorList = ["#077FFF", "#7250F9", "#59EAFA", "#E2CC80"];
        // icv
        this.icvChart = echarts.init(document.getElementById("icvChart"));
        let getDataIcv = res.data.content.info.icvList;
        let xAxisListIcv = [];
        let resGet = getDataIcv[0].timeDataMap;
        for (let key in resGet) {
          xAxisListIcv.push(key);
        }
        xAxisListIcv = xAxisListIcv.sort();
        let seriesIcv = [];
        let legendIcv = [];
        for (let i = 0; i < getDataIcv.length; i++) {
          let yData = [];
          legendIcv.push(getDataIcv[i].equipName);
          for (let j = 0; j < xAxisListIcv.length; j++) {
            yData.push(getDataIcv[i].timeDataMap[xAxisListIcv[j]]);
          }
          let setObj = {
            name: getDataIcv[i].equipName,
            type: "line",
            data: yData,
            symbol: "circle", //折点设定为实心点
            areaStyle: {
              normal: {
                // color: colorList[i], //改变区域颜色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "rgba(0,0,0,0)" },
                  { offset: 0, color: colorList[i] },
                ]),
              },
            },
            itemStyle: {
              normal: {
                color: colorList[i], //改变折线点的颜色
                lineStyle: {
                  color: colorList[i], //改变折线颜色
                },
              },
            },
          };
          seriesIcv.push(setObj);
        }
        let option = {
          legend: {
            data: legendIcv,
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 50,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 40,
            bottom: 90,
          },
          xAxis: {
            type: "category",
            data: xAxisListIcv,
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 80,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "40",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: seriesIcv,
        };
        this.icvChart.setOption(option);

        // temperature
        this.tempChart = echarts.init(document.getElementById("tempChart"));
        let getDatatemp = res.data.content.info.temperatureList;
        let xAxisListTemp = [];
        let resGetTemp = getDatatemp[0].timeDataMap;
        for (let key in resGetTemp) {
          xAxisListTemp.push(key);
        }
        xAxisListTemp = xAxisListTemp.sort();
        let seriesTemp = [];
        let legendTemp = [];
        for (let i = 0; i < getDatatemp.length; i++) {
          let yData = [];
          legendTemp.push(getDatatemp[i].equipName);
          for (let j = 0; j < xAxisListTemp.length; j++) {
            yData.push(getDatatemp[i].timeDataMap[xAxisListTemp[j]]);
          }
          let setObj = {
            name: getDatatemp[i].equipName,
            type: "line",
            data: yData,
            symbol: "circle", //折点设定为实心点
            areaStyle: {
              normal: {
                // color: colorList[i], //改变区域颜色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "rgba(0,0,0,0)" },
                  { offset: 0, color: colorList[i] },
                ]),
              },
            },
            itemStyle: {
              normal: {
                color: colorList[i], //改变折线点的颜色
                lineStyle: {
                  color: colorList[i], //改变折线颜色
                },
              },
            },
          };
          seriesTemp.push(setObj);
        }
        let optionTemp = {
          legend: {
            data: legendTemp,
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 50,
            itemHeight: 10,
            itemWidth: 20,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 40,
            bottom: 90,
          },
          xAxis: {
            type: "category",
            data: xAxisListIcv,
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 80,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "40",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: seriesTemp,
        };
        this.tempChart.setOption(optionTemp);
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.setInterFun);
    
    closeWs();
    // this.$router.push({name: 'SupplierAllBack'})
  },
  destroyed() {
    clearInterval(this.setInterFun);
    // localStorage.setItem('pageWorkId',0)
    closeWs();
  },
  components: {
    IndexHeader,
    RollLegend,
    Homez
  },
};
</script>
<style lang="scss">
#mainPageSwitch1 {
  span {
    max-width: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.canvas-container {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  // z-index: 99999;
}
.centralTable {
    .el-table__body-wrapper{
      height: 290px !important;
      overflow-y: auto !important;
    }
}
#HPIndex .warning-row {
  background: rgba(245, 108, 108, 0.1);
  color: rgb(245, 108, 108);
}
</style>

<style lang="scss" scoped="">
.centralTable {
  width: 50%;
  display: inline-block;
  height: 336px;
  // overflow-y: auto;
}
.workTable {
  border-left: 1px solid #ebeef5;
}
#mainPageSwitch1 {
  max-width: 150px;
  position: absolute;
  top: 54px;
  right: 180px;
  z-index: 999999;
  button {
    max-width: 150px;
    display: inline-block;
    color: #ffffff;
    padding: 0px 19px !important;
    background: #1c6dfe;
    border-color: #1c6dfe;
    border-radius: 16px !important;
    line-height: 32px;
    height: 32px !important;
    font-size: 15px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.indexContain {
  // height: 100%;
  // height: 1015px;
  // width: 1920px;
  background-image: url("../images/all/indexBG.png");
  padding-bottom: 17px;
  // background-size: 100% 100%;
}
.text {
  color: red;
}
.indexHeader {
  width: 100%;
  height: 90px;
}
.indexInfo {
  width: 100%;
  margin-top: 5px;
  position: relative;
  height: 967px;
  .changePro {
    width: 128px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #1c6dfe;
    border-radius: 15px;
    position: absolute;
    right: 524px;
    top: 20px;
    color: #caf1f9;
    font-size: 14px;
    cursor: pointer;
    z-index: 1000;
  }
  .infoShow {
    width: 375px;
    height: 65px;
    position: absolute;
    background-color: rgba(24, 86, 185, 0.7);
    border: 1px solid #2c83c6;
    border-radius: 4px;
    display: flex;
    top: 55px;
    left: 50%;
    transform: translateX(-50%);
    .iconImg_1 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 17px;
    }
    .iconImg_2 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 141px;
    }
    .iconImg_3 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 265px;
    }
    .icon_1 {
      background-image: url("../images/icon/icon_1.png");
      background-size: 100% 100%;
    }
    .icon_2 {
      background-image: url("../images/icon/icon_2.png");
      background-size: 100% 100%;
    }
    .icon_3 {
      background-image: url("../images/icon/icon_3.png");
      background-size: 100% 100%;
    }
    .icon_4 {
      background-image: url("../images/icon/icon_4.png");
      background-size: 100% 100%;
    }
    .icon_5 {
      background-image: url("../images/icon/icon_5.png");
      background-size: 100% 100%;
    }
    .text_1 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 44px;
      color: #56cbf6;
      font-weight: bold;
    }
    .text_2 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 168px;
      color: #56cbf6;
      font-weight: bold;
    }
    .text_3 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 293px;
      color: #56cbf6;
      font-weight: bold;
    }
    .textBig {
      font-size: 24px;
    }
    .textLow {
      font-size: 14px;
      margin-left: 3px;
    }
    .title_1 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 12px;
      top: 41px;
      left: 43px;
    }
    .title_2 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 12px;
      top: 41px;
      left: 172px;
    }
    .title_3 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 12px;
      top: 41px;
      left: 293px;
    }
  }
  .indexIcon {
    height: 22px;
    width: 19px;
    position: absolute;
    background-image: url("../images/all/indexIcon.png");
    top: 15px;
    left: 18px;
    background-size: 100% 100%;
  }
  .indexTitle {
    position: absolute;
    height: 16px;
    line-height: 16px;
    color: #ffffff;
    font-size: 16px;
    top: 19px;
    left: 45px;
    .effect {
      display: inline-block;
      width: 138px;
      height: 10px;
      background-image: url("../images/all/effect.png");
      margin-left: 12px;
    }
  }
  .progress {
    position: absolute;
    top: 0;
    right: 20px;
    width: 420px;
    height: 460px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .progressChart {
      position: absolute;
      width: 100%;
      height: 320px;
      left: 0;
      bottom: 10px;
    }
  }
  .projectTime {
    position: absolute;
    top: 0;
    left: 20px;
    width: 420px;
    height: 460px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .workTimeChart {
      position: absolute;
      width: 100%;
      height: 320px;
      left: 0;
      bottom: 10px;
    }
  }
  .mileage {
    position: absolute;
    top: 478px;
    right: 20px;
    width: 420px;
    height: 460px;
    background-image: url("../images/all/indexType_2.png");
    background-size: 100% 100%;
    .workStatusChart {
      position: absolute;
      width: 100%;
      height: 320px;
      left: 0;
      bottom: 10px;
    }
  }
  .workTime {
    position: absolute;
    top: 478px;
    left: 20px;
    width: 420px;
    height: 460px;
    background-image: url("../images/all/indexType_2.png");
    background-size: 100% 100%;
    .workAddUpTimeChart {
      position: absolute;
      width: 100%;
      height: 340px;
      left: 0;
      bottom: 0;
    }
  }
  .fbInfo {
    position: absolute;
    width: 1000px;
    height: 938px;
    background-image: url("../images/all/indexType_3.png");
    background-size: 100% 100%;
    border-radius: 5px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    .monContent{
      height: 825px;
      width: 950px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0px;
      z-index: 1000;
    }
    .changePro {
      width: 128px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1c6dfe;
      border-radius: 15px;
      position: absolute;
      right: 24px;
      top: 50px;
      color: #caf1f9;
      font-size: 14px;
      cursor: pointer;
    }
    .fbInfoType {
      position: absolute;
      top: 60px;
      left: 24px;
      height: 32px;
      width: 200px;
      display: flex;
      // background: #1c6dfe;
      // border-color:#1c6dfe;
      border-radius: 16px !important;
      overflow: hidden;
      .infoTypeItem {
        flex: 1;
        font-size: 13px;
        line-height: 32px;
        text-align: center;
        background-color: #ffffff;
        color: #1c6dfe;
        cursor: pointer;
      }
      .infoActive {
        color: #ffffff;
        background-color: #1c6dfe;
      }
    }
    .rollIcv {
      position: absolute;
      width: 100%;
      height: 850px;
      left: 0;
      bottom: 20px;
      color: #ffffff;
      opacity: 0;
      z-index: 10;
    }
    .rollNumber {
      position: absolute;
      width: 100%;
      height: 850px;
      left: 0;
      bottom: 20px;
      color: #ffffff;
      opacity: 0;
      z-index: 10;
    }
    .rollIndex {
      opacity: 1 !important;
      z-index: 100 !important;
    }
    .rnimg_1 {
      height: 80px;
      width: 240px;
      position: absolute;
      z-index: 100;
      background-image: url("../images/all/icvNum1.png");
      top: 14px;
      right: 160px;
      background-size: 100% 100%;
      opacity: 0;
      z-index: 999999;
    }
    .rnimg_2 {
      height: 80px;
      width: 240px;
      position: absolute;
      z-index: 100;
      background-image: url("../images/all/rollNum1.png");
      top: 14px;
      right: 160px;
      background-size: 100% 100%;
      opacity: 0;
      z-index: 999999;
    }
  }
  .roadInfo {
    position: absolute;
    width: 1005px;
    height: 460px;
    top: 478px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../images/all/indexType_3.png");
    background-size: 100% 100%;
    display: flex;
    border-radius: 2px;
    .rnimg {
      height: 60px;
      width: 240px;
      position: absolute;
      z-index: 100;
      background-image: url("../images/all/icvNum1.png");
      top: 14px;
      right: 21px;
      background-size: 100% 100%;
      // background-color: #e1e1e1;
    }
    .rollIcv {
      position: absolute;
      width: 100%;
      height: 400px;
      left: 0;
      bottom: 20px;
    }
  }
  .mapInfo {
    position: absolute;
    width: 1000px;
    height: 460px;
    background-image: url("../images/all/indexType_3.png");
    background-size: 100% 100%;
    border-radius: 5px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    .changePro {
      width: 128px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1c6dfe;
      border-radius: 15px;
      position: absolute;
      right: 24px;
      top: 20px;
      color: #caf1f9;
      font-size: 14px;
      cursor: pointer;
    }
    .rnimg {
      height: 60px;
      width: 240px;
      position: absolute;
      z-index: 100;
      background-image: url("../images/all/rollNum1.png");
      top: 14px;
      right: 21px;
      background-size: 100% 100%;
      // background-color: #e1e1e1;
    }
    .rollNumber {
      position: absolute;
      width: 100%;
      height: 400px;
      left: 0;
      bottom: 20px;
    }
  }
}
.rollLegend {
  position: relative;
  left: 550px;
  transform: scale(0.55);
  bottom: 20px;
}
.canvasContent{
  position: absolute;
  left: 0;
  bottom: 0;
  height: 750px;
  width: 990px;
  z-index: 1000;
}
#midCanvasm{
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1000;
}
#dhCanvasm{
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999999999;
}
#show-iframe{
  position: absolute;
  width: 950px;
  height: 870px;
  // top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  background-color: white;
  bottom: 24px;
}
.show-iframe-con{
  position: absolute;
  width: 1000px;
  height: 960px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  background-color: rgba(11, 67, 160, 0.7);
  border: 1px solid #2d99c3;
  border-radius: 15px;
} 
</style>